/* VAELO - scroll reveal. Adds the hiding class only after JS is confirmed running,
   so a script failure leaves the page fully visible instead of blank. */
(function () {
  var root = document.documentElement;
  if (!("IntersectionObserver" in window)) return;
  root.classList.add("v-js");
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
  function scan(scope) {
    var els = (scope || document).querySelectorAll(".v-reveal:not(.is-in)");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.vSeen) continue;
      el.dataset.vSeen = "1";
      var stagger = el.closest("[data-v-stagger]");
      if (stagger) {
        var sibs = Array.prototype.slice.call(stagger.querySelectorAll(".v-reveal"));
        el.style.transitionDelay = Math.min(sibs.indexOf(el), 7) * 70 + "ms";
      }
      io.observe(el);
    }
  }
  function failsafe() {
    setTimeout(function () {
      var stuck = document.querySelectorAll(".v-reveal:not(.is-in)");
      for (var i = 0; i < stuck.length; i++) {
        var r = stuck[i].getBoundingClientRect();
        if (r.top < window.innerHeight) stuck[i].classList.add("is-in");
      }
    }, 2500);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function(){ scan(); failsafe(); });
  } else { scan(); failsafe(); }
  document.addEventListener("shopify:section:load", function (e) {
    var els = e.target.querySelectorAll(".v-reveal");
    for (var i = 0; i < els.length; i++) els[i].classList.add("is-in");
  });
})();